/* eslint-disable */
import { axios } from "~/plugins/axios";

const getDefaultState_Reports = () => {
  return {
    result: {},
  }
}
const state = getDefaultState_Reports();

const getters = {
  result: state => state.result,
  call: state => state.call,
}

const actions = {
  async getReportElements({commit}, reportName) {
    return await axios.get(`/api/reports/${reportName}/elements`)
      .then(resp => {
        return resp.data;
      }).catch(err => console.log(err));
  },
}

const mutations = {
  SET_RESULT(state, payload) {
    state.result = payload
  },

  RESET_STATE_REPORTS (state) {
    Object.assign(state, getDefaultState_Reports())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
